// ce fichier est pret a être utilisé ci le systeme d'erreur évolue
export default function translate(i18n, propriete) {
  return propriete;
}
